import { Skeleton } from "@/shared/components/ui/skeleton";

const ROW_COUNT = 8;

export function UsersTableSkeleton() {
  return (
    <div
      data-testid="users-table-loading"
      className="overflow-hidden rounded-lg border border-border bg-card"
    >
      <div className="space-y-3 p-4">
        {Array.from({ length: ROW_COUNT }).map((_, i) => (
          <div key={i} className="flex items-center gap-4">
            <Skeleton className="h-10 flex-1" />
            <Skeleton className="h-6 w-20" />
            <Skeleton className="h-6 w-20" />
            <Skeleton className="h-6 w-24" />
            <Skeleton className="h-6 w-24" />
          </div>
        ))}
      </div>
    </div>
  );
}
